import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIs = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h25v18H0z", fill: "#003087" }), /* @__PURE__ */ React.createElement("path", { d: "M0 9h25M9 0v18", strokeWidth: 4, stroke: "#FFF" }), /* @__PURE__ */ React.createElement("path", { d: "M0 9h25M9 0v18", strokeWidth: 2, stroke: "#D50032" }));
const ForwardRef = forwardRef(SvgIs);
const Memo = memo(ForwardRef);
export default Memo;
